module.exports = __webpack_public_path__ + "img/icone-organization.d5b33bf1.svg";